// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b53aeefb","455":"98beef80"}[chunkId] + ".chunk.js";
};